<template>
  <div>
    <oie-order-return-issue-attachments :order-return="orderReturn" :order="order"></oie-order-return-issue-attachments>

    <h2 v-if="rows.length > 0" v-epi-edit="'orderRowsHeader'" class="order-return-container__section-heading">
      {{ t('followYourOrderReturnIssue') }}
    </h2>

    <div class="issue-messages">
      <div v-for="(row, key) in rows" :key="`table-row-${key}`" class="issue-message">
        <div class="issue-message-header">
          <div class="issue-message-sender">
            <div class="issue-message-sender-avatar">
              <img :src="row.senderAvatarUrl">
            </div>
            <div class="issue-message-sender-name">
              {{ row.sender }}
            </div>
          </div><div class="issue-message-date">
            {{ (new Date(row.sent)).toLocaleDateString(clientModel.currentLanguage, dateOptions) }}
          </div>
        </div>
        <span>{{ row.content }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    orderReturn: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    selectedRows: [],
    unselectedRows: [],
    selectedOrderReturnReason: null,
    machineType: null,
    dateOptions: {
      day: 'numeric',
      month: 'long'
    }
  }),
  computed: {
    selectAll: {
      get() {
        const unselectedRows = _.filter(this.rows, (row) => !_.includes(this.selectedRows, row))

        return this.selectedRows.length > 0 && unselectedRows.length === 0
      },
      set(value) {
        if (!value) {
          this.selectedRows = []
        } else {
          this.selectedRows = [...this.rows]
        }
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">

  .issue-messages {
    width: 100%;
    max-width: 45rem;
  }

  .issue-message {
    background-color: #F0F0F0;
    border-radius: 1.2rem;
    margin-bottom: 1rem;
    padding: .8rem;
    white-space: pre-line;
  }

  .issue-message-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    margin-bottom: .2rem;
  }

  .issue-message-sender {
    display: flex;
    align-items: center;
  }

  .issue-message-sender-avatar {
  }

  .issue-message-sender-avatar > img {
    width: 48px;
    height: 48px;
  }

  .issue-message-sender-name {
    margin-left: .5rem;
    white-space: normal;
  }

  .issue-message-date {
  }
</style>
